import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/partners/fetch-funebra/{dossier}'
*/
const FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d.url(args, options),
    method: 'post',
})

FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-funebra/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/partners/fetch-funebra/{dossier}'
*/
FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/partners/fetch-funebra/{dossier}'
*/
FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/dossier/{dossier}/funebra'
*/
const FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.url(args, options),
    method: 'get',
})

FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/funebra',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/dossier/{dossier}/funebra'
*/
FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/dossier/{dossier}/funebra'
*/
FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFunebraController.php
* @route '/api/dossier/{dossier}/funebra'
*/
FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierFunebraController::FetchDossierFunebraController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierFunebraController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierFunebraController = {
    '/api/partners/fetch-funebra/{dossier}': FetchDossierFunebraControllerf95879549b79733b1d5cf89d41860c1d,
    '/api/dossier/{dossier}/funebra': FetchDossierFunebraControllered67d8ad019a5db0b9643f6f8f3c142f,
}

export default FetchDossierFunebraController